import { Attachment, EntityStatus, Translations, UUID } from '@/types/types';
import { Asset } from './AssetApi';
import { AttributeValue } from './AttributeValueApi';
import { QueryKey } from '@/configs/queryKeys';
import EntityApi, { BaseEntity } from './EntityApi';

export enum AccessoryType {
	ACCESS_CONTROL = 'access_control',
	DRIVER = 'driver',
	LED = 'led',
	CABLE_GLAND = 'cable_gland',
}

export enum LedType {
	NONE = 'NONE',
	LED_TAPE = 'LED_TAPE',
	LED_POINT = 'LED_POINT',
	LED_PLUG = 'LED_PLUG',
}

export interface LedTapeConfig {
	maxTapeLength: number;
	gapBetweenTapes: number;
	minDistanceToEdges: number;
	minDistanceToPosts: number;
}

export interface AccessoryCustomField {
	name: string;
	description: string;
	required: boolean;
	translations: Translations<{
		name: string;
		description: string;
	}>;
}

export interface AccessoryAvailabilityConditions {
	upperEnding: boolean;
	lowerEnding: boolean;
	requiredAccessoryIds: UUID[];
}

export interface Accessory extends BaseEntity {
	name: string;
	description: string;
	image: Attachment | null;
	attributeValues: AttributeValue[];
	attributeValuesIds: UUID[];
	type: AccessoryType;
	listOrder: number;
	model3d?: Asset;
	isSlotHosted: boolean;
	requireMiddlePost: boolean;
	hostSlotName: string;
	defaultAttributeValues: Record<UUID, UUID | null>;
	customFields: AccessoryCustomField[];
	availabilityConditions: AccessoryAvailabilityConditions;
	requiredAttributesIds: UUID[];
	ledType: LedType;
	ledTapeConfig: LedTapeConfig;
	status: EntityStatus;
	translations: Translations<{
		name: string;
		description: string;
	}>;
}

class AccessoryApi extends EntityApi<Accessory> {
	constructor() {
		super(QueryKey.accessories);
	}
}

export default new AccessoryApi();
